import { render, staticRenderFns } from "./PcqDsiCreateUpdate.vue?vue&type=template&id=e4c2a80a&scoped=true&"
import script from "./PcqDsiCreateUpdate.vue?vue&type=script&lang=js&"
export * from "./PcqDsiCreateUpdate.vue?vue&type=script&lang=js&"
import style0 from "./PcqDsiCreateUpdate.vue?vue&type=style&index=0&id=e4c2a80a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4c2a80a",
  null
  
)

export default component.exports